/** @jsxImportSource @emotion/react */

import React, { FC } from 'react';
import { css } from '@emotion/react';

const outerStyle = css({
    padding: '4rem 0'
});
const innerStyle = css({
    maxWidth: 800,
    margin: '0 auto',
    padding: '0 3rem',
    display: 'block'
});
const gridStyle = css({
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    gridTemplateRows: 'auto',
    gridTemplateAreas: "'form form' 'visualizer visualizer' 'help help'",
    columnGap: '1rem',
    rowGap: '1rem',
    '@media (min-width: 800px)': {
        gridTemplateAreas: "'form visualizer' 'help help'"
    }
});

const Body: FC = ({ children }) => (
<div className="Body" css={outerStyle}>
    <div className="BodyInner" css={innerStyle} role='main'>
        <div css={gridStyle}>
            { children }
        </div>
    </div>
</div>
);

export default Body;
